export const BLUE = '#647dfc';
export const REQUEST_LINE_CHART = ['#647dfc', '#ff0000'];
